module.exports = __webpack_public_path__ + "img/termo_perso.97b02688.png";